// Constants
import {
  ADDONS,
  BRAND_REQUEST_EMAIL,
  BRAND_REQUEST_STATUS,
  COMPANY_TYPES_BILLING
} from '@/constants'
// Components
import CardContainerElement from '@/components/ui/CardContainerElement'
import FormButtons from '@/components/ui/FormButtons'
// Mixins
import uiMixin from '@/mixins/uiMixin'
import addonsMixin from '@/mixins/addonsMixin'
// Services
import { sendAnySendinblueEmail } from '@/services/email'
// Vuex
import { mapActions, mapGetters } from 'vuex'
// Utils
import { get } from 'lodash'
import { humanizePlaceObject } from '@/filters'

export default {
  name: 'CompanyBrandRequestForm',
  components: {
    CardContainerElement,
    FormButtons
  },
  mixins: [addonsMixin, uiMixin],
  data() {
    return {
      requestData: null,
      processingRequest: false
    }
  },
  computed: {
    ...mapGetters('authentication', ['userData']),
    ...mapGetters('company', ['companyData']),
    /**
     * Valor actual de la petición
     *
     * @return {string}
     */
    brandRequestStatus() {
      return get(
        this.companyAddonsSetupByUser,
        `${ADDONS.company}.brandRequestStatus`,
        BRAND_REQUEST_STATUS.notSend.value
      )
    },
    /**
     * ¿Fue enviada la petición?
     *
     * @return {boolean}
     */
    requestWasSended() {
      return this.brandRequestStatus === BRAND_REQUEST_STATUS.pending.value
    },
    /**
     * ¿Fue rechazada la peticion?
     *
     * @return {boolean}
     */
    requestWasRejected() {
      return this.brandRequestStatus === BRAND_REQUEST_STATUS.rejected.value
    }
  },
  async mounted() {
    await this.getEveryNeededData()
  },
  methods: {
    ...mapActions('company', ['updateCompanyConfigsData']),
    /**
     * Lanzado cuando pulsamos sobre "Aceptar"
     */
    async handleRequestButton() {
      this.modifyAppAlert({
        actionButtonFn: async () => {
          await this.sendAndSaveRequest()
        },
        actionButtonText: 'Enviar',
        text: '¿Estas seguro que deseas enviarnos la solicitud?',
        type: 'warning',
        visible: true
      })
    },

    /**
     * Obtenemos y seteamos todos los elementos necesarios
     * para la carga inicial del componente
     */
    async getEveryNeededData() {
      this.setRequestData()
    },
    /**
     * Reunimos (establecemos) los datos que deseamos enviar
     * en la solicitud
     */
    setRequestData() {
      const companyConfig = get(this.companyAddonsSetupByUser, ADDONS.company, {})

      // Datos de facturación
      this.requestData = {
        id: this.companyData.id,
        name: this.userData.name,
        email: this.userData.email,
        companyType: get(COMPANY_TYPES_BILLING, `${companyConfig.billingCompanyType}.label`, null),
        address: humanizePlaceObject(companyConfig.billingAddress),
        extraAddress: companyConfig.billingExtraAddress,
        cif: companyConfig.cif
      }
    },
    /**
     * Enviamos email y almacenamos el estado de la petición
     */
    async sendAndSaveRequest() {
      // Loading
      this.processingRequest = true
      try {
        const dataToSave = {
          id: this.companyData.id,
          addOns: [
            {
              id: ADDONS.company,
              configFields: {
                brandRequestStatus: BRAND_REQUEST_STATUS.pending.value
              }
            }
          ]
        }

        // Enviamos email
        await sendAnySendinblueEmail({
          method: 'partnerBrandRequest',
          email: BRAND_REQUEST_EMAIL,
          name: 'Sistema automatizado',
          customParams: this.requestData
        })

        // Actualizamos configuraciones
        await this.updateCompanyConfigsData(dataToSave)

        // show info
        this.modifyAppAlert({
          text:
            'La solicitud fue enviada correctamente. Le contestaremos en la mayor brevedad posible.',
          type: 'info',
          visible: true
        })
      } catch (error) {
        // show error
        this.modifyAppAlert({
          text: error.message,
          type: 'error',
          visible: true
        })
      } finally {
        this.processingRequest = false
      }
    }
  }
}
